const fromNb = t => t.replace(',', '.').replace('−', '-').replaceAll('&nbsp;', '');
const toNorwegian = (num, d) => num.toLocaleString('no-NO', {
  minimumFractionDigits: d, maximumFractionDigits: d
}).replace('-', '−');

export const toNumber = (unknownLocale) => {
  let s = unknownLocale;
  if (unknownLocale.indexOf('.') > -1) s = unknownLocale.replaceAll(',', '');
  else s = fromNb(unknownLocale);
  return Number(s);
};

export const tableFromJson = (jsonArray, samlet) => {
  const choice = samlet ? 'samlet' : 'plan';
  const columns = [
    { label: 'Plantegn', key: 'title' },
    { label: 'Kommune', key: 'kommune' },
    { label: 'Arealbruk', key: 'arealbruk' },
    { label: 'Arealbruk plan', key: 'arealbruk_plan' },
    { label: 'Dekar', key: 'dekar' },
    { label: 'Tonn CO<sub>2</sub>-ekv. 5 år', key: `tiltakseffekt_05_${choice}` },
    { label: 'Tonn CO<sub>2</sub>-ekv. 20 år', key: `tiltakseffekt_20_${choice}` },
    { label: 'Tonn CO<sub>2</sub>-ekv. 75 år', key: `tiltakseffekt_75_${choice}` },
  ];

  const queryable = document.createElement('html');
  const t = document.createElement('table');
  t.id = 'utslipp';
  const thead = t.createTHead();
  const tr0 = thead.insertRow();
  columns.forEach(c => {
    const th = document.createElement('th');
    th.innerHTML = c.label;
    tr0.appendChild(th);
  });
  const tbody = t.createTBody();
  jsonArray.forEach(j => {
    j.dekar = j.dekar || j.hektar * 10;
    const tr = tbody.insertRow();
    columns.forEach(c => {
      const td = tr.insertCell();
      td.innerHTML = j[c.key] ?? '';
    });
  });
  queryable.appendChild(t);
  return queryable;
};

export const findInHeader = (word, tableHeader) => {
  const index = [];
  if (Array.isArray(word)) {
    // word.forEach(w => index.concat(findInHeader(w, tableHeader))); //not work
    word.forEach(w => index.push(...findInHeader(w, tableHeader)));
  } else {
    const tr = tableHeader.getElementsByTagName('tr')[0];
    const h = tr.getElementsByTagName('th');
    Array.from(h).forEach((th, i) => {
      if (th.innerHTML.indexOf(word) > -1) index.push(i);
    });
  }
  return index;
};

export const removeColumn = (table, column) => {
  const indexArray = findInHeader(column, table.firstElementChild);
  const columnIndex = (indexArray.length > 0) ? indexArray[0] : null;
  Array.from(table.rows).forEach(tr => tr.cells.item(columnIndex).remove());
};

export const sumRows = (table, planidFilter, kommuneFilter) => {
  const tableBody = table.getElementsByTagName('tbody')[0];
  const r = tableBody.rows;
  const nr = r.length;
  const nc = r[0]?.cells.length ?? 0;
  const sum = new Array(nc).fill(0);
  for (let i = 0; i < nr; i++) {
    const row = r[i];
    const c = row.cells;
    if ( // sum only chosen group (planid-komm)
      (!planidFilter || (planidFilter === text(c[0]))) &&
      (!kommuneFilter || (kommuneFilter === text(c[1])))
    ) for (let k = 0; k < nc; k++) sum[k] += toNumber(c[k].innerHTML);
  }
  return sum.map(v => Math.round(v * 100) / 100);
};

const addSummaryToTable = (table) => {
  // Create an empty <tfoot> element and add it to the table:
  const footer = table.tFoot || table.createTFoot();
  footer.innerHTML = ''; // Hvis det fantes fra før
  if (table.tBodies[0].rows.length > 1) {
    const sum = sumRows(table);
    const dp = findInHeader('Dekar', table);
    // Create an empty <tr> element and add it to the footer:
    const tr = footer.insertRow();
    tr.className = 'summary';
    const nc = sum.length;
    sum.forEach((s, i) => {
      const d = (i === dp[0]) ? 1 : 0; // Bare dekar vil ha en desimal
      const td = document.createElement('td');
      // td.innerHTML = (i < 4) ? ((i === 0) ? 'Sum' : '') : s;
      td.innerHTML = (i < nc - 4) ? '' : toNorwegian(s, d);
      tr.appendChild(td);
    });
  };
};

export const localeAndSummary = (table) => {
  const dp = findInHeader('Dekar', table);
  const tableBody = table.getElementsByTagName('tbody')[0];
  const r = tableBody.rows;
  const nr = r.length;
  const nc = r[0]?.cells.length ?? 0;
  for (let i = 0; i < nr; i++) {
    const row = r[i];
    const c = row.cells;
    for (let k = 3; k < nc; k++) {
      const d = (k === dp[0]) ? 1 : 0; // Bare dekar vil ha en desimal
      const v = c[k].innerHTML.replace(/^-0$/, '0');
      // English format does not pass isNaN (i.e. '1,638.74'):
      const en = /\d,\d\d\d\.\d\d$/.test(v);
      const s = en ? v.replaceAll(',', '') : v;
      if (s !== '' && !isNaN(s)) c[k].innerHTML = toNorwegian(+s, d);
    }
  }
  addSummaryToTable(table);
};

export const table2csv = (table, emptyColumns) => {
  const rs = [];
  for (let i = 0, row; row = table.rows[i]; i++) {
    const cs = [];
    for (let j = 0, cell; cell = row.cells[j]; j++) {
      // console.log(cell.innerHTML, cell.innerText);
      cs.push('"' + cell.innerText.replaceAll(' ', '') + '"');
    }
    if (emptyColumns) { // add empty columns to be aligned with original table
      const el = emptyColumns.length;
      for (let e = 0; e < el; e++) cs.splice(emptyColumns[e], 0, '');
    }
    rs.push(cs.join(';'));
  }
  return rs.join('\n');
};

export const activateClickInteractions = () => {
  const results = document.getElementById('resultsContent');
  const a = document.getElementById('toggleCurrentEmissions').firstElementChild;
  a.onclick = () => results.classList.toggle('opened');
  const comparisonP = document.getElementById('toggleComparedEmissions');
  const comparisonA = comparisonP.firstElementChild;
  comparisonA.onclick = () => results.classList.toggle('openComparedEmissions');
  const p = document.getElementById('togglePlannedEmissions').firstElementChild;
  p.onclick = () => results.classList.toggle('openPlannedEmissions');
};

export const compareTables = (currentEmissions, plannedEmissions) => {
  const sum = {};
  const currentEmissionsRows = currentEmissions.rows;
  for (let i = 1, row; row = currentEmissionsRows[i]; i++) {
    if (!row.cells[0]) continue;
    const p = text(row.cells[0]);
    const k = text(row.cells[1]);
    if ((sum[p] && sum[p][k]) || !p || p === 'Sum') continue;
    const pk = {
      current: sumRows(currentEmissions, p, k),
      planned: sumRows(plannedEmissions, p, k)
    };
    if (sum[p]) sum[p][k] = pk;
    else sum[p] = { [k]: pk };
  }
  const piC = findInHeader('Plantegn', currentEmissions.firstElementChild);
  const kiC = findInHeader('Kommune', currentEmissions.firstElementChild);
  const diC = findInHeader('Dekar', currentEmissions.firstElementChild);
  const tiC = findInHeader('Tonn', currentEmissions.firstElementChild);
  const selectedColumnsC = piC.concat(kiC).concat(diC).concat(tiC);
  const piP = findInHeader('Plantegn', plannedEmissions.firstElementChild);
  const kiP = findInHeader('Kommune', plannedEmissions.firstElementChild);
  const diP = findInHeader('Dekar', plannedEmissions.firstElementChild);
  const tiP = findInHeader('Tonn', plannedEmissions.firstElementChild);
  const selectedColumnsP = piP.concat(kiP).concat(diP).concat(tiP);
  const tbody = document.createElement('tbody');
  Object.entries(sum).forEach(([planid, kommuner]) => {
    Object.entries(kommuner).forEach(([k, s]) => {
      const tr = document.createElement('tr');
      for (let i = 0; i < selectedColumnsC.length; i++) {
        const td = document.createElement('td');
        if (i === 0) td.innerHTML = planid; // planid
        else if (i === 1) td.innerHTML = k; // kommune
        else {
          const c = s.current[selectedColumnsC[i]];
          if (i === 2) td.innerHTML = c.toLocaleString('no-NO'); // dekar
          else {
            const p = s.planned[selectedColumnsP[i]];
            td.innerHTML = (p - c).toLocaleString('no-NO'); // utslipp
          }
        }
        tr.appendChild(td);
      }
      tbody.appendChild(tr);
    });
  });
  comparedEmissions.tBodies[0].replaceWith(tbody);
  // if (comparedEmissions.rows.length === 3) comparedEmissions.deleteRow(-1);
  addSummaryToTable(comparedEmissions);
  return comparedEmissions;
};

export const totalEmissionsFromTable = (table) => {
  const tableHeader = table.getElementsByTagName('thead')[0];
  const index = findInHeader('Tonn', tableHeader);
  const sumOfRows = sumRows(table).map(x => x.toLocaleString('no-NO'));
  const t5 = `${sumOfRows[index[0]]} tCO<sub>2</sub>`;
  const t20 = `${sumOfRows[index[1]]} tCO<sub>2</sub>`;
  const t75 = `${sumOfRows[index[2]]} tCO<sub>2</sub>`;
  return [t5, t20, t75];
};

const text = td => td.innerHTML;
// const text = td => td.querySelector('.text')?.innerHTML || '';
